<template>
  <div class="actions-row">
    <template v-if="isReady">
      <!-- Preview button -->
      <el-button
        type="primary"
        title="Watch Video"
        plain
        size="mini"
        class="videoItemButton"
        @click="$emit('preview')"
      >
        <television title="Watch Video" class="videoItemIcon" />
      </el-button>

      <!-- Download button -->
      <el-button
        type="success"
        title="Download Video"
        size="mini"
        class="videoItemButton"
        @click="$emit('download')"
      >
        <download title="Download Video" class="videoItemIcon" />
      </el-button>

      <!-- Copy link video button -->
      <el-button
        type="success"
        title="Clone a video"
        size="mini"
        class="videoItemButton displayNone"
        @click="$emit('cloneVideo')"
      >
        <copyright title="Clone a video" class="videoItemIcon" />
      </el-button>

      <!-- Copy video button -->
      <el-button
        type="success"
        title="Copy Link"
        size="mini"
        class="videoItemButton"
        @click="$emit('copy')"
      >
        <content-copy title="Copy Link" class="videoItemIcon" />
      </el-button>

      <!-- Edit video button -->
      <el-button
        type="warning"
        title="Edit Video"
        plain
        size="mini"
        class="videoItemButton"
        @click="$emit('edit')"
      >
        <movie-edit title="Edit Video" class="videoItemIcon" />
      </el-button>

      <!-- Cut video button -->
      <el-button
        type="warning"
        title="Cut Video"
        plain
        size="mini"
        class="videoItemButton displayNone"
        @click="$emit('cut')"
      >
        <content-cut title="Edit Video" class="videoItemIcon" />
      </el-button>

      <!-- GIF generating button -->
      <el-button
        type="warning"
        title="Generate GIF"
        plain
        size="mini"
        class="videoItemButton"
        @click="$emit('gif')"
      >
        <gif title="Generate GIF" class="videoItemIcon" />
      </el-button>
    </template>

    <!-- Remove video button -->
    <el-button
      v-if="isRemovable"
      type="danger"
      title="Delete Video"
      size="mini"
      class="videoItemButton"
      @click="$emit('delete')"
    >
      <close-thick title="Delete Video" class="videoItemIcon" />
    </el-button>
  </div>
</template>

<script>
/** icons */
import Download from "vue-material-design-icons/Download.vue";
import ContentCopy from "vue-material-design-icons/ContentCopy.vue";
import Television from "vue-material-design-icons/Television.vue";
import CloseThick from "vue-material-design-icons/CloseThick.vue";
import Gif from "vue-material-design-icons/Gif.vue";
import MovieEdit from "vue-material-design-icons/MovieEdit.vue";
import ContentCut from "vue-material-design-icons/ContentCut.vue";
import Copyright from "vue-material-design-icons/Copyright.vue";

// @group Media/Video
// Video actions panel
export default {
  name: "VideoHeaderActions",
  components: {
    /** icons */
    Download,
    ContentCopy,
    Television,
    CloseThick,
    Gif,
    MovieEdit,
    ContentCut,
    Copyright
  },
  props: {
    /** Is covertion finished */
    isReady: {
      type: Boolean,
      default: true
    },
    /** Is it possible to delete video */
    isRemovable: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style lang="scss" scoped>
.actions-row {
  display: flex;
}

.displayNone {
  display: none;
}

/** buttons */
.videoItemButton {
  height: 2rem !important;
  width: 2rem !important;
  margin: 0 5px;
}
.material-design-icon__svg {
  padding-left: 2px;
  height: 1rem !important;
  width: 1rem !important;
  margin-top: 1px !important;
}

@media only screen and (max-width: 440px) {
  /** buttons */
  .videoItemButton {
    height: 1.6rem !important;
    width: 1.6rem !important;
    margin: 0 2px;
  }
  .material-design-icon__svg {
    padding-left: 2px;
    height: 0.8rem !important;
    width: 0.8rem !important;
    margin-top: 1px !important;
  }
}
@media only screen and (min-width: 992px) {
  .material-design-icon__svg {
    height: 0.7rem !important;
    width: 0.7rem !important;
    margin-top: 2px !important;
  }
  .videoItemButton {
    height: 1.8rem !important;
    width: 1.8rem !important;
    margin: 0 2px;
  }
}
@media only screen and (min-width: 1200px) {
  .material-design-icon__svg {
    height: 1rem !important;
    width: 1rem !important;
    margin-top: 2px !important;
  }
  .videoItemButton {
    height: 2rem !important;
    width: 2rem !important;
  }
}
@media only screen and (min-width: 1920px) {
  .material-design-icon__svg {
    height: 1rem !important;
    width: 1rem !important;
    margin-top: 2px !important;
  }
}
</style>
